import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { ActiveDataRoomLenderSummaryReport, Guid } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useActiveLenderSummaryReportQuery(
	dataRoomGuid?: Guid | undefined,
	options?:
		| Omit<
				UseQueryOptions<ActiveDataRoomLenderSummaryReport[], unknown, ActiveDataRoomLenderSummaryReport[], any>,
				'queryKey' | 'queryFn'
		  >
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoom.ActiveLenderSummaryReport(dataRoomGuid),
		() =>
			AxiosUtils.getResponseData<ActiveDataRoomLenderSummaryReport[]>(
				api.get(CerebroApiEndpoints.DataRooms.ActiveLenderSummaryReport(dataRoomGuid))
			),
		options
	);
}
